import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { normalizePathname } from 'utilities/normalizePathname';

const useDismissNotificationOnNavigation = (
  pathname: string,
  dismiss: () => void
): void => {
  const history = useHistory();

  useEffect(() => {
    const unlisten = history.listen(location => {
      if (
        normalizePathname(location.pathname) !== normalizePathname(pathname)
      ) {
        dismiss();
      }
    });
    return unlisten;
  }, [history, pathname, dismiss]);
};

export default useDismissNotificationOnNavigation;
